// Note: This class shared utils specific to CLM directory
import {Router} from '@angular/router';
import {CaseType} from '../../types';
import {ClaimDisplayDTO} from '../../models/claim/ClaimDisplayDTO';
import {ClmRoutes, ProcessingClassSubTypeDBMapping} from '../../types/types';
import {ProviderDTO} from 'src/app/modules/ent/models/ProviderDTO';

export enum PayToAcronymEnum {
  'Policyholder' = 'PH',
  'Policyholder Group' = 'PHG',
  'Provider' = 'P',
  'Provider Group' = 'PG',
  'Broker' = 'BR',
  'Broker Group' = 'BRG',
  'Beneficiary' = 'M',
  'Nominated Beneficiary' = 'NB',
  'Alternative Beneficiary' = 'AB',
  'Estate' = 'E'
}

export class ClmFunctions {
  public static getPayToAcronym(payTo: string): string {
    return PayToAcronymEnum[payTo] ?? '';
  }

  public static getCaseUrl(row: ClaimDisplayDTO, router: Router): string {
    let url: string;
    if (row.processingClass === CaseType.Medical) {
      const processingSubClassId = Number(row.processingSubClassId);

      if (processingSubClassId === ProcessingClassSubTypeDBMapping.Pharmacy) {
        url = router.createUrlTree([`${ClmRoutes.EditPharmacyCase}/${row.caseNumber}`]).toString();
      }
      else {
        url = router.createUrlTree([`${ClmRoutes.EditHospitalCase}/${row.caseNumber}`]).toString();
      }
    }
    else if (row.processingClass === CaseType.Funeral) {
      url = router.createUrlTree([`${ClmRoutes.EditFuneralCase}/${row.caseNumber}`]).toString();
    }
    return url;
  }
}

export function getProviderDisplayString(provider: ProviderDTO): string {
  const { practiceNumber, businessLicenseNumber, entityStatus, providerNetworkList } = provider;
  return `${practiceNumber ? practiceNumber : businessLicenseNumber}: ${provider.name} | ${entityStatus?.name} | ${providerNetworkList}`;
}

export function isValidCommaSeparatedNumberList(numberList: string): boolean {
  const valueToTest = numberList.replace(/\s/g, '');
  const patternForValidNumbersList = /^(\d+(,\d+)*)?$/; // regex validates a string representing a list of numbers separated by commas
  return patternForValidNumbersList.test(valueToTest);
}
